import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-cloud-region-resources';

@Injectable({
  providedIn: 'root'
})
export class CloudRegionService {

  constructor(private fabricService: FabricService) {}

  getTenantRegionPairs():any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_region-pairs');
  }

  getTenantRegions():any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_regions');
  }

}
